import React, { FC, useState } from "react";
import Link from "next/link";
import { observer } from "mobx-react";
import Badge from "ui/Badge/Badge";
import { useStore } from "store";
import { useApi } from "services/ApiService";
import { LinkProps } from "helpers/url";
import CombinedTooltip from "../CombinedTooltip/CombinedTooltip";
import ProductInfo from "../ProductInfo/ProductInfo";
import styles from "./BundleBadge.module.scss";

type Props = {
  item: Entity.Product.BundleBadge;
  showCounter: boolean;
  count?: number;
  productLink?: LinkProps;
};

const BundleBadge: FC<Props> = ({
  item,
  showCounter,
  count,
  productLink,
}: Props) => {
  const { location } = useStore();
  const [product, setProduct] = useState(null);
  const {
    methods: { products },
  } = useApi();

  const onOpen = async () => {
    if (product) return;

    const { data, errors } = await products.search({
      search: {
        productIDs: [item.id],
        regionID: location.regionID,
      },
    });

    if (data?.products && data?.products.items.length) {
      setProduct(data?.products.items[0]);
    }

    if (errors) {
      console.error(errors);
    }
  };

  return (
    <CombinedTooltip
      placement="bottom-start"
      tooltipContent={
        <ProductInfo product={product} onOpen={onOpen} type="tooltip" />
      }
      item={item}
    >
      <div className={styles.badgeContainer}>
        <Badge color="lightGray" className={styles.badgeContainerBadge}>
          {item.shortName + (item.quantity > 1 ? ` x${item.quantity}` : "")}
        </Badge>

        {showCounter && (
          <Link
            {...productLink}
            className={styles.badgeCounter}
            onClick={e => {
              e.stopPropagation();
            }}
            passHref
          >
            <Badge color="lightGray">+{count}</Badge>
          </Link>
        )}
      </div>
    </CombinedTooltip>
  );
};

export default observer(BundleBadge);
